import { map as Rmap } from "ramda";
import { Truck, buildNewTruck } from "@/models/Truck";

interface TruckState {
  trucks: Truck[];
  truck: Truck;
}

const state: TruckState = {
  trucks: [],
  truck: buildNewTruck(),
};

const mutations = {
  LOAD_TRUCKS(state: TruckState, payload: Truck[]) {
    state.trucks = payload;
  },

  LOAD_TRUCK(state: TruckState, payload: Truck) {
    state.truck = payload;
  },
};

const actions = {
  loadTrucks(context: any, trucks: Truck[]) {
    return new Promise((resolve, _reject) => {
      context.commit("LOAD_TRUCKS", trucks);
      resolve(trucks);
    });
  },

  loadTruck(context: any, truck: Truck) {
    return new Promise((resolve, _reject) => {
      context.commit("LOAD_TRUCK", truck);
      resolve(truck);
    });
  },
};

const getters = {
  trucks: (state: TruckState) => {
    return state.trucks;
  },
  truck: (state: TruckState) => {
    return state.truck;
  },
  trucksForAutocompleteId: (state: TruckState) => {
    // map over the items and just return a label and an id
    return Rmap(truck => {
      return {
        id: truck.id,
        label: truck.name,
      };
    }, state.trucks);
  },
};

const trucksModule = {
  state,
  mutations,
  actions,
  getters,
};

export default trucksModule;
